import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";
import { Typography, Divider } from "antd";
import styles from "./SidebarContent.module.less";

interface Props {
  children: JSX.Element | JSX.Element[];
  title: string;
}
const { Title, Text } = Typography;
const cx = classnames.bind(styles);

const SidebarContent = (props: Props) => {
  const { title, children } = props;

  return (
    <div className={cx("container")}>
      <div className={cx("sidebar")}>
        <Title className={cx("sidebar--title")}>
          Portal <br /> Sistema de gestion integral de Casos
        </Title>
        {process.env.REACT_APP_VERSION}
      </div>

      <div className={cx("content")}>
        <Text className={cx("content--title")}>{title}</Text>
        <Divider className={cx("content--divider")} />

        {children}
      </div>
    </div>
  );
};

SidebarContent.propTypes = {
  title: PropTypes.string.isRequired,
};

export default SidebarContent;
